const translations = {
  "sidebar.Payments": "Payments",
  "sidebar.Dashboard": "Dashboard",
  "sidebar.Finances": "Finances",
  "sidebar.References": "References",
  "sidebar.Reports": "Reports",
  "sidebar.MainPage": "Main page",
  "sidebar.Documentation": "Documentation",
  "sidebar.ProductsAndProviders": "Products and providers",
  "sidebar.InvoicesAndGraphs": "Invoices and graphs",
  "sidebar.Changes": "Changes",
  "sidebar.CorrectPersonalData": "Personal data to be corrected",
  "sidebar.Documents": "Documents",
  "sidebar.Confirmations": "Confirmations",
  "sidebar.reallywantCancel?":
    "Are you sure you want to cancel the consultation?",
  "sidebar.no": "No",
  "sidebar.yesInformal": "Yes",
};

export default translations;
